export let json = {
  "@type": "HowToDirection",
  "text": "Place the tile sheets along the wall, making sure to add spacers so the tiles remain lined up."
}